// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';

interface SchGConsultantExpensesFormDTO { 
  consultantType: string | null;
  consultantName: string | null;
  firstName: string | null;
  middleInitial: string | null;
  lastName: string | null;
  consultantAutoFillId: string | null;
  summaryId: string | null;
  paymentDate: moment.Moment | string | null;
  paymentAmount: number;
  explanation: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  phoneNumber: string | null;
  relationshipCode: string | null;
  isLivingOrRevocableTrust: boolean;
  trustee: string | null;
  trustor: string | null;
  auditorsNoteId: string | null;
}
const SchGConsultantExpensesFormDTO = {
  create: (initValues?: Partial<SchGConsultantExpensesFormDTO> | Record<string, unknown> | null) => {
    return Object.assign(
    {
      consultantType: null,
      consultantName: null,
      firstName: null,
      middleInitial: null,
      lastName: null,
      consultantAutoFillId: null,
      summaryId: null,
      paymentDate: null,
      paymentAmount: 0,
      explanation: null,
      addressLine1: null,
      addressLine2: null,
      city: null,
      state: null,
      zip: null,
      phoneNumber: null,
      relationshipCode: null,
      isLivingOrRevocableTrust: false,
      trustee: null,
      trustor: null,
      auditorsNoteId: null,
    },
    initValues);
  }
};

export default SchGConsultantExpensesFormDTO;